import moment from 'moment'

import api from '@/utils/api'
import STATUS from '@/utils/status'
import timeService from '@/utils/timeService'

import _ from 'lodash'

let newConversation = {
  id: -1,
  kind: 'conversation',
  messages: [],
  lastMessage: '',
  lastMessageTime: 0,
  lastTimeOfView: 0,
  nbMessages: 0,
  onObject: null,
  participants: [],
  senders: [],
  title: 'New conversation',
  unreadMessages: 0
}

const state = {
  conversationsUpdateCount: 0,
  lastViewInConversations: moment().unix(),
  conversations: {
    data: [],
    status: STATUS.LOADING,
    nextUrl: null,
    view: 'inbox'
  }
}

const mutations = {
  setView (state, view) {
    state.conversations.view = view
  },
  setConversationsUpdateCount (state, nb) {
    state.conversationsUpdateCount = nb
  },
  setConversations (state, conversations) {
    state.conversations.data = conversations
  },
  appendConversations (state, data) {
    state.conversations.data = _.uniqBy(state.conversations.data.concat(data.conversations), (c) => c.id)
    state.conversations.status = STATUS.LOADED
    if (data.conversations.length === 0) {
      state.conversations.nextUrl = null
    } else {
      state.conversations.nextUrl = data.nextApiCall
    }
  },
  setConversationsStatus (state, status) {
    state.conversations.status = status
  },
  setNextUrl (state, url) {
    state.conversations.nextUrl = url
  }
  // ,
  // markAsUnread (state, conversation) {
  //   conversation.
  // }
}

const actions = {
  showArchived (ctx) {
    ctx.commit('setView', 'archives')
  },
  showInbox (ctx) {
    ctx.commit('setView', 'inbox')
  },
  showAll (ctx) {
    ctx.commit('setView', 'all')
  },
  load (ctx, options) {
    ctx.commit('setConversationsStatus', STATUS.LOADING)
    ctx.commit('setNextUrl', null)
    ctx.commit('setConversations', [])
    let groopsParam = -1
    if (ctx.rootGetters['groops/groops'] !== options.groops) {
      groopsParam = options.groops.map((group) => group.id).join(',')
    }
    let searchObject = ctx.rootGetters['search/searchObject']
    let searchCriteria = {
      texts: searchObject.texts,
      from: ctx.rootGetters['search/searchKeyedValues']('from'),
      is: ctx.rootGetters['search/searchKeyedValues']('is')
    }
    return api.get('/conversations/' + (state.conversations.view || 'inbox'), {params: {
      group: groopsParam,
      searchCriteria: searchCriteria
    }}).then((response) => {
      ctx.commit('setConversations', response.data.conversations)
      ctx.commit('setNextUrl', response.data.nextApiCall)
      ctx.commit('setConversationsStatus', STATUS.LOADED)
    }).catch(() => {
      ctx.commit('setConversationsStatus', STATUS.ERROR)
    })
  },
  loadMore (ctx, options) {
    let groopsParam = -1
    if (ctx.rootGetters['groops/groops'] !== options.groops) {
      groopsParam = options.groops.map((group) => group.id).join(',')
    }
    let searchObject = ctx.rootGetters['search/searchObject']
    let searchCriteria = {
      texts: searchObject.texts,
      from: ctx.rootGetters['search/searchKeyedValues']('from'),
      is: ctx.rootGetters['search/searchKeyedValues']('is')
    }
    return api.get(ctx.state.conversations.nextUrl, {params: {group: groopsParam, searchCriteria: searchCriteria}}).then((response) => {
      ctx.commit('appendConversations', response.data)
    })
  },
  clean (ctx) {
    ctx.commit('setConversationsStatus', STATUS.LOADING)
    ctx.commit('setConversations', [])
    ctx.commit('setNextUrl', null)
  },
  searchConversationWithId (ctx, id) {
    return _.find(ctx.state.conversations.data, (c) => c.id === id)
  },
  getConversation (ctx, convOrIdOrNull) {
    return new Promise((resolve, reject) => {
      if (convOrIdOrNull != null) {
        if (_.isNumber(convOrIdOrNull)) {
          let id = convOrIdOrNull
          ctx.dispatch('searchConversationWithId', id).then((conv) => {
            if (conv) {
              resolve(conv)
            } else {
              api.get(`/conversation/${convOrIdOrNull}`).then((response) => {
                resolve(response.data.conversation)
              }).catch(() => {
                reject()
              })
            }
          }).catch(() => {
            reject()
          })
        } else {
          // this.status = STATUS.LOADED
          // return this.sharedObject.conversation
        }
      } else {
        return ctx.dispatch('newConversation')
      }
    })
  },
  sendMessage (ctx, data) {
//    conversation.messages.push(message)
    let time = moment().unix() + timeService.getServerTimeDelta()
    let message = {
      sender: ctx.rootState.user.connectedUser,
      time: time,
      text: data.message,
      id: 0 - time,
      sending: true
    }
    data.conversation.messages.push(message)
    if (data.conversation.id !== -1 && !data.conversation.inCreation) {
      return api.post('/message', {
        convId: data.conversation.id,
        message: data.message
      }).catch((error) => {
        data.conversation.messages = data.conversation.messages.filter((m) => m !== message)
        throw error
      }).then((response) => {
        message.sending = false
        message.id = response.data.message.id
        console.log(message)
      })
    } else {
      data.conversation.inCreation = false
      if (data.conversation.onObject) {
        return api.post('/messageOnSharedObject', {
          sharedObjectId: data.conversation.onObject.id,
          kind: data.conversation.onObject.kind,
          message: data.message
        }).catch((error) => {
          data.conversation.messages = data.conversation.messages.filter((m) => m !== message)
          throw error
        }).then((received) => {
          data.conversation.id = received.data.conversation.id
          data.conversation.onObject.conversation = received.data.conversation.id
          data.conversation.messages = received.data.messages
          data.conversation.nbMessages = received.data.conversation.nbMessages
          data.conversation.participants = received.data.conversation.participants
          data.conversation.lastMessage = received.data.conversation.lastMessage
          data.conversation.lastTimeOfView = received.data.conversation.lastTimeOfView
          data.conversation.lastMessageTime = received.data.conversation.lastMessageTime
          message.sending = false
        })
      } else if (data.conversation.chatUsersIds) {
        return api.post('chatConversation', {users: data.conversation.chatUsersIds, message: data.message})
        .then((response) => {
          data.conversation.id = response.data.conversation.id
          data.conversation.messages = response.data.messages
          data.conversation.lastMessage = response.data.conversation.lastMessage
          data.conversation.nbMessages = response.data.conversation.nbMessages
          data.conversation.participants = response.data.conversation.participants
          data.conversation.lastMessageTime = response.data.conversation.lastMessageTime
          // ctx.dispatch('sendMessage', data)
          return response.data.conversation
        })
      } else {
        return api.post('/conversation', {
          title: data.conversation.title,
          participants: _.map(data.conversation.participants, (p) => {
            return {
              kind: p.kind,
              id: p.id
            }
          }),
          message: data.message
        }).then((received) => {
          data.conversation.id = received.data.conversation.id
          data.conversation.messages = received.data.messages
          data.conversation.lastMessage = received.data.conversation.lastMessage
          data.conversation.nbMessages = received.data.conversation.nbMessages
          data.conversation.participants = received.data.conversation.participants
          // data.conversation.lastTimeOfView = received.data.conversation.lastTimeOfView // show message as unread
          data.conversation.lastMessageTime = received.data.conversation.lastMessageTime
          message.sending = false
        }).catch((error) => {
          data.conversation.inCreation = true
          data.conversation.messages = data.conversation.messages.filter((m) => m !== message)
          throw error
        })
      }
    }
  },
  markAsRead (ctx, conversation) {
  },
  markAllAsRead (ctx) {
    return api.put('/conversations/markAllAsRead', {
      groups: ctx.rootGetters['groops/selectedGroopsId']
    })
  },
  newConversation (ctx, options) {
    let userOrGroupOrNull = null
    let chatUsersIds = null
    if (options && options.forChat) {
      chatUsersIds = options.forChat
      options = null
    }
    let conv = _.cloneDeep(newConversation)
    conv.lastMessageTime = moment().unix()
    conv.lastTimeOfView = conv.lastMessageTime
    conv.lastMessageTimeFixed = conv.lastMessageTime
    conv.inCreation = true
    conv.id = 0 - moment().unix() + ''
    conv.title = ''
    conv.chatUsersIds = chatUsersIds
    let user = ctx.rootState.user.connectedUser
    conv.senders = [user]
    conv.participants = []
    if (userOrGroupOrNull != null) {
      conv.participants.push(userOrGroupOrNull)
    } else if (!ctx.rootGetters['groops/isAllGroopsSelected']) {
      _.forEach(ctx.rootState.groops.selectedGroops, (groop) => {
        conv.participants.push(groop)
      })
    }
    conv.messages = []
    ctx.state.conversations.data.push(conv)
    return conv
    // this.showInbox();
    // _this.group.conversations["inbox"].elems.push(conv);
  },
  removeConversation (ctx, conversation) {
    if (conversation.inCreation) {
      ctx.state.conversations.data = _.filter(ctx.state.conversations.data, (c) => c.id !== conversation.id)
    }
  },
  setConversationsUpdateCount ({commit}, nb) {
    commit('setConversationsUpdateCount', nb)
  },
  addMarkOneMoreAsUnread ({commit, state}) {
    commit('setConversationsUpdateCount', parseInt(state.conversationsUpdateCount) + 1)
  },
  addMarkOneMoreAsRead ({commit, state}) {
    commit('setConversationsUpdateCount', Math.max(parseInt(state.conversationsUpdateCount) - 1, 0))
  },
  archive (ctx, conversation) {
    conversation.archived = true
    api.put('/conversation/' + conversation.id, {
      status: 'archived'
    })
    if (ctx.state.conversations.view === 'inbox') {
      ctx.state.conversations.data = _.filter(ctx.state.conversations.data, (c) => c.id !== conversation.id)
    }
  },
  toInbox (ctx, conversation) {
    conversation.archived = false
    api.put('/conversation/' + conversation.id, {
      status: 'inbox'
    })
    if (ctx.state.conversations.view === 'archives') {
      ctx.state.conversations.data = _.filter(ctx.state.conversations.data, (c) => c.id !== conversation.id)
    }
  },
  refreshConversation (ctx, conversation) {
    api.get(`/conversation/${conversation.id}`).then((response) => {
      this.conversation.messages = response.data.messages
    }).catch(() => {
    })
  }
}

const getters = {
  conversationsUpdateCount (state) {
    return state.conversationsUpdateCount
  },
  conversationsStatus (state) {
    return state.conversations.status
  },
  conversations (state) {
    return state.conversations.data
  },
  hasNextConversations (state) {
    return state.conversations.nextUrl !== null
  },
  view (state) {
    return state.conversations.view || 'inbox'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/conversations.js